const initialState = {
  buyerProducts: []
};

const ProductSearchServiceReducer = (state = initialState, action) => {
  if (action.type === 'GET_BUYER_PRODUCTS') {
    return {
      ...state,
      buyerProducts: action?.payload
    };
  } else {
    return state;
  }
};

export default ProductSearchServiceReducer;
